import { createContext } from "react";
const defaultContext = {
  log: () => {
  },
  error: () => {
  },
  warn: () => {
  }
};
/**
 * @type {Context<LoggerType>}  -- @preserve
 * @export  -- @preserve
 */
const LoggerContext = createContext(defaultContext);
const extendLogger = (originalLogger, prefix) => {
  return {
    error: (...args) => {
      return void originalLogger.error(prefix, ...args);
    },
    log: (...args) => {
      return void originalLogger.log(prefix, ...args);
    },
    warn: (...args) => {
      return void originalLogger.warn(prefix, ...args);
    },
    prefix
  };
};
export {
  LoggerContext,
  extendLogger
};
//# sourceMappingURL=logger.context.js.map
